import { Box } from "@mui/material";
import { type CancelShiftPolicy } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { Text } from "@src/appV2/redesign/system/ui-components";

interface ExampleItem {
  title: string;
  pillText: string;
}

interface LifeHappensExamplesCardProps {
  cancellationPolicy: CancelShiftPolicy[];
}

export function LifeHappensExamplesCard(props: LifeHappensExamplesCardProps) {
  const { cancellationPolicy } = props;
  const sortedCancellationPolicy = cancellationPolicy.sort((a, b) => {
    return b.points - a.points;
  });

  // limit to first 3
  const EXAMPLES: ExampleItem[] = sortedCancellationPolicy.slice(0, 3).map((item) => ({
    title: `Cancel ${item.leadTime[0]}h in advance`,
    pillText: `${item.points} pts`,
  }));

  EXAMPLES.push({
    title: "No show",
    pillText: "Instant Restriction",
  });

  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: 12,
        paddingX: 2,
      }}
    >
      <Box
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          borderRadius: "25px",
          padding: theme.spacing(6),
          boxShadow: "0px 4px 4px 0px rgba(0,0,0,0.05)",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          minHeight: "70px",
        })}
      >
        <Text
          sx={(theme) => ({
            fontSize: "14px",
            fontWeight: 500,
            color: theme.palette.text.tertiary,
            lineHeight: "16px",
            textAlign: "left",
            paddingLeft: theme.spacing(1),
          })}
        >
          Example:
        </Text>
        {EXAMPLES.map((item) => (
          <Box
            key={item.title}
            sx={(theme) => ({
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              paddingRight: theme.spacing(1),
            })}
          >
            <Text
              sx={(theme) => ({
                fontSize: "16px",
                fontWeight: 500,
                color: theme.palette.text.primary,
                lineHeight: "17px",
                paddingLeft: theme.spacing(1),
              })}
            >
              {item.title}
            </Text>
            <Box
              sx={(theme) => ({
                backgroundColor: theme.palette.intent?.error.background,
                borderRadius: "100px",
                paddingX: theme.spacing(3),
                paddingY: theme.spacing(0.75),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "22px",
              })}
            >
              <Text
                sx={(theme) => ({
                  fontSize: "12px",
                  fontWeight: 500,
                  color: theme.palette.intent?.error.text,
                  lineHeight: "14.5px",
                })}
              >
                {item.pillText}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
